// extracted by mini-css-extract-plugin
export default {"container":"cgs4v7irs"};